"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Hover Effect',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.titlePlacement === _constants.GALLERY_CONSTS.placements.SHOW_ON_HOVER;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.infoBehaviourOnHover.APPEARS,
  options: (0, _utils.createOptions)('infoBehaviourOnHover'),
  description: "Determines whether the info appears or disappears or always shown or never shown on when hovering over items.\n  "
};
exports["default"] = _default;